import * as React from 'react';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { useAxios } from '../../utils/hooks.ts';

export default function CopyEnvironmentStatus({ visible, hide, environment, allEnvironments, displayToast, flipFetchFlag }) {
    const [ sourceEnvironmentId, setSourceEnvironmentId ] = React.useState(null);
    const [ saving, setSaving ] = React.useState(false);
    const axiosInstance = useAxios();

    const otherEnvironments = (allEnvironments || []).filter(e => e.environmentId !== environment.environmentId);

    const close = () => {
        setSourceEnvironmentId(null);
        hide();
    }

    const copyStatus = () => {
        setSaving(true);
        axiosInstance.current.put("/flags/status/environment/" + sourceEnvironmentId + "/copy-to/" + environment.environmentId)
            .then(() => {
                displayToast({ severity: 'success', summary: 'Copied!', detail: 'Flag statuses copied successfully!'});
                flipFetchFlag();
            })
            .catch(() => {
                displayToast({ severity: 'error', summary: 'Error!', detail: 'Unable to copy flag statuses'});
            })
            .finally(() => {
                setSaving(false);
                close();
            })
    }

    return (
        <Dialog header={"Copy Flag Statuses into " + environment.name} visible={visible} onHide={close}>
            <div className="flex-col center">
                <div className="card">
                    <div className="field m20">
                        Copy every matching flag's enabled/disabled status from another environment into <b>{environment.name}</b>. Flags that don't already exist in <b>{environment.name}</b> will be skipped.
                    </div>
                    <div className="field m20">
                        <Dropdown
                            style={{ width: '100%' }}
                            placeholder="Select source environment"
                            optionLabel="name"
                            optionValue="environmentId"
                            value={sourceEnvironmentId}
                            options={otherEnvironments}
                            onChange={(e) => setSourceEnvironmentId(e.value)}
                        />
                    </div>
                    <div className="flex-row center mt20">
                        <Button style={{ margin: 20 }} label="Copy Statuses" icon="pi pi-copy" loading={saving} disabled={!sourceEnvironmentId} onClick={copyStatus} />
                    </div>
                </div>
            </div>
        </Dialog>
    )
}
